import AuthReducer from "./auth";
import ArtistReducer from "./artist";
import RecruiterReducer from "./recruiter";
import AuditionReducer from "./auditions";
import ProfileCategoryReducer from "./profileCategory";
import ProjectCategoryReducer from "./projectCategory";
import RoleTypeReducer from "./roleType";
import ProjectReducer from "./project";
import GeneralReducer from "./general";
import KycReducer from "./kyc";
import NotificationReducer from "./notification";

/**
 * @author Sarthak Sharma
 * @since 02-01-2024
 * @description to combine admin reducers
 */

const adminReducer = {
  authReducer: AuthReducer,
  artistReducer: ArtistReducer,
  kycReducer: KycReducer,
  recruiterReducer: RecruiterReducer,
  auditionReducer: AuditionReducer,
  profileCategoryReducer: ProfileCategoryReducer,
  projectCategoryReducer: ProjectCategoryReducer,
  roleTypeReducer: RoleTypeReducer,
  projectReducer: ProjectReducer,
  generalReducer: GeneralReducer,
  notificationReducer: NotificationReducer,
};

export default adminReducer;
